// extracted by mini-css-extract-plugin
var _1 = "content___GMBvn";
var _2 = "description___o5Dt7";
export { _1 as "content", _2 as "description" }
